'use client';

import React__default from 'react';
import { colors } from '../Utils/constants.js';
import { Container, Link, Name } from './TrustedCompanyName.css.js';

var iconSizes = {
    xs: 12,
    sm: 14,
    md: 15
};
var TrustedCompanyName = function (props) {
    var // isTrusted = false,
    size = props.size, _a = props.color, color = _a === void 0 ? colors.textColor : _a, _b = props.style, style = _b === void 0 ? {} : _b, _c = props.className, className = _c === void 0 ? '' : _c, href = props.href, name = props.name; props.tooltip;
    /**
     * VNW-19840 [Web] Remove "Trusted" tag all page
     *
     * Set isTrusted = false
     * @author PhongGP
     * @since Dec 26, 2022
     */
    var isTrusted = false;
    var sizeType = 'md';
    var fontSize = 0;
    var iconSize = 0;
    if (typeof size === 'string') {
        sizeType = size;
    }
    else {
        fontSize = (size === null || size === void 0 ? void 0 : size.fontSize) || 0;
        iconSize = (size === null || size === void 0 ? void 0 : size.iconSize) || 0;
    }
    return (React__default.createElement(Container, { style: style, className: className, size: sizeType, fontSize: fontSize, isTrusted: isTrusted, paddingRight: iconSize !== 0 ? iconSize + 6 : iconSizes[sizeType] + 6 },
        href ? (React__default.createElement(Link, { title: name, color: color, className: 'trusted-company-name', href: href, target: '_blank' }, name)) : (React__default.createElement(Name, { title: name, color: color, className: 'trusted-company-name' }, name)),
        (React__default.createElement(React__default.Fragment, null))));
};

export { TrustedCompanyName as default };
//# sourceMappingURL=index.js.map
